<template>
    <div class="header-unit" ref="mobileheader">
        <div class="mobile-holder" v-if="isMobile">
            <div class="mobile-top">
                <a href="/" class="logo"><inline-svg src="/images/svg/logo.svg" title="Dowd & Dowd P.C."/></a>
                <button
                popovertarget="mobile-nav"
                class="hamburger"
                :class="{ toggled: isToggled }"
                @click="isToggled = !isToggled"
                >
                <inline-svg src="/images/svg/hamburger.svg" title="Hamburger menu" />
                </button>
            </div>
            <div class="gradient border"></div>
            <div class="mobile-nav" popover id="mobile-nav">
                <ul class="breadcrumbs">
                    <li>
                        <button v-if="breadcrumbs.length" class="clear crumb" @click.prevent="goToStart()">
                            Home
                        </button>
                        <a href="/" v-else>Home</a>
                    </li>
                    <li v-for="(breadcrumb, i) in breadcrumbs">
                        <button class="clear crumb" @click.prevent="goTo(breadcrumb.id, breadcrumb.link)" v-if="i < breadcrumbs.length - 1">{{ breadcrumb.title }}</button>
                        <a v-else :href="breadcrumb.link">{{ breadcrumb.title }}</a>
                    </li>
                </ul>
                <div class="nav-holder">
                    <slot :expand="expand" name="mobile"></slot>
                </div>
            </div>
        </div>
        <div class="desktop-holder" v-else>
                <div class="desktop-top">
                    <a href="/" class="logo"><inline-svg src="/images/svg/logo.svg" title="Dowd & Dowd P.C."/></a>
                </div>
                <div class="nav-holder">
                    <slot :expand="expand" name="desktop"></slot>
                </div>
                <div class="gradient border"></div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const breadcrumbs = ref([]);
const mobileheader = ref(null);
const isToggled = ref(false);
const isMobile = ref(false);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 768;
  if(isMobile.value === true && mobileheader.value.querySelector('.hamburger.toggled')){
    mobileheader.value.querySelector('#mobile-nav').showPopover();
  }
}


const expand = (id, title, link) =>{
    document.querySelector('ul[data-id="'+id+'"]').classList.add('open');
    const exists = breadcrumbs.value.some(item => item.link === link)
    if (!exists) {
        breadcrumbs.value.push({
            id,
            title,
            link
        })
    }
}

const goTo = (id, link) => {

    let open = mobileheader.value.querySelectorAll('li > ul.sub.open');
    if(open){
        open.forEach(ul => ul.classList.remove('open'));
    }

    const index = breadcrumbs.value.findIndex(b => b.link === link)

    if (index !== -1) {
        breadcrumbs.value = breadcrumbs.value.slice(0, index + 1)
    }

    document.querySelector('ul[data-id="'+id+'"]').classList.add('open');
}

const goToStart = () =>{
    breadcrumbs.value = [];
    mobileheader.value.querySelectorAll('.sub').forEach(el => {
        el.classList.remove('open');
    });
}

onMounted(() => {
    window.addEventListener('resize', checkIsMobile)
    checkIsMobile();

    let activePages = mobileheader.value.querySelectorAll('li a[data-id="'+document.body.dataset.id+'"], li button[data-id="'+document.body.dataset.id+'"]');
    
    activePages.forEach(a => {
        if(a.dataset.classname == document.body.dataset.classname){
            a.classList.add('active');
        }
    })

    let uls = mobileheader.value.querySelectorAll('ul:has(li a.active), ul:has(li button.active), button.active ~ ul');
    uls.forEach(u => {
        if(u.classList.contains('sub')){
            u.classList.add('open')
        }
    })

    let lis = mobileheader.value.querySelectorAll('ul li:has(a.active), ul li:has(button.active)');
    lis.forEach(l => {
        let childButton = l.querySelector(':scope > button');

        if (childButton) {
            breadcrumbs.value.push({
                id: childButton.dataset.id,
                title: childButton.textContent.trim(),
                link: childButton.dataset.link
            });
        }
    });

    onUnmounted(() => {
        window.removeEventListener('resize', checkIsMobile)
    })
});
</script>
